<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'StopsParking',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
        alignment: 'right',
      }, {
        dataField: 'Begin',
        caption: 'Время начала остановки',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
        alignment: 'center',
      }, {
        dataField: 'BeginLocation',
        caption: 'Место стоянки',
      }, {
        dataField: 'End',
        caption: 'Время окончания остановки',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
        alignment: 'center',
      }, {
        dataField: 'Duration',
        caption: 'Длительность остановки',
        width: 130,
        alignment: 'center',
      }, {
        dataField: 'RideTime',
        caption: 'Время в пути',
        width: 100,
        alignment: 'center',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      reportSummary: [],
      summary: null,
    };
  },
  watch: {
    reportData () {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
      this.getSummary();
      this.getAddresses();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
    this.getAddresses();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (item.column.dataField === 'Begin' || item.column.dataField === 'BeginLocation') {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (item.column.dataField === 'End') {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    convertSummaryData (data) {
      const rows = [];
      data.Data.Data.forEach((items) => {
        items.Rows.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
      });
      this.reportSummary = rows;
    },

    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
          });
        } else {
          this.reportData.Data.Data.forEach((obj) => {
            obj.Rows.forEach((row) => {
              this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row) {
      const row = _row;
      row.BeginLocation = null;
      setImmediate(async () => {
        row.BeginLocation = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
      });
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              if (options.groupIndex === undefined) {
                const totalValue = this.reportData.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                this.index = 0;
              } else {
                value.totalValue = this.reportData.Data.Data[this.index]?.SumDuration;
                this.index += 1;
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },
  },
};
</script>
